import { PROCESS } from "@/lib/brand";

export const Process = () => {
  return (
    <section
      id="processo"
      data-testid="process-section"
      className="relative py-24 lg:py-36 bg-[#0a0a0a] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-[#facc15]" />
              <span className="text-[11px] uppercase tracking-[0.32em] text-[#facc15] font-bold">
                Como Funciona
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-white">
              Do primeiro contato à
              <span className="italic text-[#facc15]"> entrega final</span>.
            </h2>
          </div>
          <p className="lg:col-span-5 lg:col-start-8 self-end text-zinc-400 leading-relaxed">
            Um processo enxuto, transparente e respeitoso com o seu tempo.
            Você acompanha cada etapa e recebe um projeto sob medida, sem
            surpresas.
          </p>
        </div>

        <ol className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {PROCESS.map((p, i) => (
            <li
              key={p.n}
              data-testid={`process-step-${p.n}`}
              className="relative bg-[#0a0a0a] p-10 min-h-[280px] flex flex-col"
            >
              <div className="flex items-center gap-4 mb-6">
                <span className="font-display text-[64px] leading-none text-[#facc15]">
                  {p.n}
                </span>
                <span className="h-px flex-1 bg-white/15" />
              </div>
              <h3 className="font-display text-2xl text-white">{p.title}</h3>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
                {p.desc}
              </p>
              {i < PROCESS.length - 1 && (
                <span className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 text-[#facc15] text-xl">
                  →
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
